import React, { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
//Icons
import { MdDelete } from "react-icons/md";
import { ImKey } from "react-icons/im";
import { TbEdit } from "react-icons/tb";

import EditNoteIcon from "@mui/icons-material/EditNote";
import { RiEdit2Fill } from "react-icons/ri";
import { TbPasswordUser } from "react-icons/tb";
import CreateIcon from "@mui/icons-material/Create";

//Srcs
import "../../Style/actionStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import { UpdateUser } from "./UpdateUser";
import { UpdatePassword } from "./UpdatePassword";

export default function UserAction({ editData, setRefetch, userLogin }) {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal reset
  const [openUpdatePwd, setOpenUpdatePwd] = useState(false);
  const handleOpenUpdatePwd = () => setOpenUpdatePwd(true);
  const handleCloseUpdatePwd = () => setOpenUpdatePwd(false);

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title={t("tooltip-reset")} placement="top">
          <IconButton onClick={handleOpenUpdatePwd}>
            <Box className="reset-pwd-container">
              <TbPasswordUser className="reset-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title={t("tooltip-update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <CreateIcon className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <UpdateUser
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
      />
      <UpdatePassword
        open={openUpdatePwd}
        handleClose={handleCloseUpdatePwd}
        editData={editData}
        setRefetch={setRefetch}
      />
    </div>
  );
}
